//--- React
import { useSelector } from "react-redux";
//--- Ant Design
import { Col, Divider, Row } from "antd";
//--- Project
import "./style.css";
import BRAKE_ICON from "assets/images/icons/brakeIcon.svg";
import { UNITS } from "components/Common/Constants";

const BrakeAlalytics = () => {
  const tripSummary = useSelector((state) => state.testRide.tripSummary);

  const innerContent = (
    title,
    minTitle,
    minValue,
    maxTitle,
    maxValue,
    minUnit,
    maxUnit
  ) => {
    return (
      <Row className="border pd1 h100">
        <Col span={24} className="text-center highlight-title">
          {title}
        </Col>
        <Col span={24} className="mt1 mb025">
          <Row justify={"space-evenly"}>
            <Col className="text-center">
              {minValue ? (
                <div>
                  <span className="avg-count">{minValue}</span>
                  <span className="card-sub-text ml015">{minUnit}</span>
                </div>
              ) : (
                <div className="disabled ml025 mb05">NA</div>
              )}
              <div className="card-sub-text text-center">{minTitle}</div>
            </Col>
            {maxTitle ? (
              <>
                <Col>
                  <Divider className="h100" type={"vertical"} />
                </Col>
                <Col className="text-center">
                  {maxValue ? (
                    <div>
                      <span className="avg-count">{maxValue}</span>
                      <span className="card-sub-text ml015">
                        {maxUnit || minUnit}
                      </span>
                    </div>
                  ) : (
                    <div className="disabled ml025 mb05">NA</div>
                  )}
                  <div className="card-sub-text">{maxTitle}</div>
                </Col>
              </>
            ) : null}
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <Row gutter={[16, 10]} className="highlight">
      <Col span={24}>
        <Row gutter={[16, 16]} align={"middle"} className="mt1">
          <Col className="align-center">
            <img src={BRAKE_ICON} alt="view" height={24} />
          </Col>
          <Col className="sub-title">Brakes Analytics</Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row gutter={[16, 16]} className="h100">
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Avg Distance",
              "",
              tripSummary?.averageDistancePerBrake,
              null,
              null,
              UNITS.METER
            )}
          </Col>
          <Col xs={24} md={12} lg={6}>
            {innerContent(
              "Avg Duration",
              null,
              tripSummary?.averageDurationPerBrake,
              null,
              null,
              UNITS.SECONDS
            )}
          </Col>
          <Col xs={24} md={12} lg={6}>
            {innerContent("Total Brakes", "", tripSummary?.totalBrakes)}
          </Col>
          <Col xs={24} md={12} lg={6}>
            {innerContent("Brakes Per Km", null, tripSummary?.brakesPerKm)}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default BrakeAlalytics;
